// @mui

import { GetVisitByIdVisitTypeEnum } from 'woofwoof-api';
import { mapVisitTypeToLabel } from '../../utils/mapVisitTypeToLabel';
import Iconify from '../iconify';
import Label from '../label';
// ----------------------------------------------------------------------

interface VisitTypeBadgeProps {
  visitType?: GetVisitByIdVisitTypeEnum;
}

export default function VisitTypeBadge({ visitType }: VisitTypeBadgeProps) {
  const label = mapVisitTypeToLabel(visitType);

  if (!visitType) {
    return null;
  }

  if (visitType === GetVisitByIdVisitTypeEnum.Onsite) {
    return (
      <Label
        variant="soft"
        color="primary"
        sx={{ textTransform: 'none', width: 'fit-content' }}
        startIcon={<Iconify icon="solar:home-add-bold" />}
      >
        {label}
      </Label>
    );
  }

  if (visitType === GetVisitByIdVisitTypeEnum.Video) {
    return (
      <Label
        variant="soft"
        color="warning"
        sx={{ textTransform: 'none', width: 'fit-content' }}
        startIcon={<Iconify icon="solar:videocamera-record-bold" />}
      >
        {label}
      </Label>
    );
  }

  if (visitType === GetVisitByIdVisitTypeEnum.Chat) {
    return (
      <Label
        variant="soft"
        color="error"
        sx={{ textTransform: 'none', width: 'fit-content' }}
        startIcon={<Iconify icon="solar:chat-dots-bold" />}
      >
        {label}
      </Label>
    );
  }

  if (visitType === GetVisitByIdVisitTypeEnum.Mobile) {
    return (
      <Label
        variant="soft"
        color="success"
        sx={{ textTransform: 'none', width: 'fit-content' }}
        startIcon={<Iconify icon="solar:map-point-hospital-bold" />}
      >
        {label}
      </Label>
    );
  }

  return null;
}
